<div
  class="px-5 py-8 shadow-lg btn-container">
  <button
    type="button"
    class="btn app-btn-yellow btn-outline w-100 py-6 fs-5"
    (click)="createNewTask()"
  >
    Create new task
  </button>
</div>
